module.exports = __webpack_public_path__ + "8e55970ba59ec302107e1251677054f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/fedex_2_2023_chart.png
// module id = 1674
// module chunks = 0